(() => {
  const page = document.querySelector('.bbx-page');
  if (!page) return;

  const params = new URL(window.location.href).searchParams;
  if (params.get('bd_mobile_qa') === '1') {
    page.classList.add('bbx-force-mobile');
    document.body.classList.add('bbx-mobile-qa');
  }

  const header = page.querySelector('[data-bbx-header]');
  const menu = page.querySelector('[data-bbx-menu]');
  menu?.addEventListener('click', () => {
    const open = header?.dataset.open !== 'true';
    if (header) header.dataset.open = String(open);
    menu.setAttribute('aria-expanded', String(open));
  });

  const slides = [...page.querySelectorAll('[data-bbx-slide]')];
  const thumbs = [...page.querySelectorAll('[data-bbx-thumb]')];
  const selectSlide = (index, scrollThumb = true) => {
    const normalized = ((Number(index) % slides.length) + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === normalized;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    thumbs.forEach((item, thumbIndex) => {
      const active = thumbIndex === normalized;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
      if (active && scrollThumb) item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  };
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      selectSlide(thumb.dataset.bbxThumb, false);
    });
  });
  page.querySelector('[data-bbx-prev]')?.addEventListener('click', () => {
    const current = slides.findIndex((slide) => !slide.hidden);
    selectSlide(current - 1);
  });
  page.querySelector('[data-bbx-next]')?.addEventListener('click', () => {
    const current = slides.findIndex((slide) => !slide.hidden);
    selectSlide(current + 1);
  });

  page.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = page.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
